import { appInsights } from '../appInsights';

export function getTraceIdFromResponse(response) {
    if (!response || !response.headers) {
        return undefined;
    }

    return response.headers.get('x-trace-id') || undefined;
}

export async function readApiErrorPayload(response) {
    const traceId = getTraceIdFromResponse(response);

    try {
        const json = await response.json();
        return {
            status: response.status,
            traceId: traceId,
            code: json && json.code ? json.code : undefined,
            message: json && json.message ? json.message : (json ? JSON.stringify(json) : response.statusText)
        };
    } catch (e) {
        try {
            const text = await response.text();
            return { status: response.status, traceId: traceId, message: text || response.statusText };
        } catch (e2) {
            return { status: response.status, traceId: traceId, message: response.statusText };
        }
    }
}

export function trackApiError(operation, method, requestUrl, apiError) {
    const message = (apiError && apiError.message) ? apiError.message : 'API call failed';

    appInsights.trackException({
        exception: new Error(message),
        properties: {
            operation: operation,
            method: method,
            url: requestUrl,
            status: apiError && apiError.status ? String(apiError.status) : undefined,
            code: apiError && apiError.code ? String(apiError.code) : undefined,
            traceId: apiError && apiError.traceId ? String(apiError.traceId) : undefined
        }
    });
}